import {
  ConfirmPrimitiveReservationInput,
  MakePrimitiveReservation,
  PageStepper
} from '../../types/cart'
import { validateConfirmPrimitiveInput } from './validateConfirmPrimitiveInput'

export function isContinueDisabled(
  page: PageStepper,
  confirmPrimitiveInput: ConfirmPrimitiveReservationInput,
  cartItemCount: number,
  isTimeExpired: boolean,
  loadingForMakePrimitive: boolean,
  loadingForConfirmPrimitiveData: boolean,
  primitiveData?: MakePrimitiveReservation
): boolean {
  if (
    page === 'form' &&
    (!primitiveData ||
      primitiveData.reservationNumber !==
        confirmPrimitiveInput.reservationNumber ||
      !validateConfirmPrimitiveInput(confirmPrimitiveInput))
  ) {
    return true
  }
  if (page === 'cart' && cartItemCount === 0) {
    return true
  }
  return (
    isTimeExpired || loadingForMakePrimitive || loadingForConfirmPrimitiveData
  )
}
